import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Grid, Divider, Skeleton } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
// utilities
import { formatEnum } from "../../../utils/string";
// components
import TextSkeletonContainer from "../../Skeleton/TextSkeletonContainer";


// Helper Component to Render Selected Permissions
const PermissionList = ({ permissionData }) => {
    return permissionData.map((permission, index) => (
      <Grid item xs={12} sm={6} md={2.4} key={`permission-${index}`}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <CheckIcon sx={{ fontSize: 18, color: "#1d1b20", mr: 1 }} />
          <Typography variant="body2" sx={{ color: "#1d1b20" }}>
            {formatEnum(permission.name)}
          </Typography>
        </Box>
      </Grid>
    ));
  };
  
  const RoleDisplayContainer = () => {
    const formData = useSelector((state) => state.roleStepper.formData);
    const modules = useSelector((state) => state.roleStepper.modules);
    const roleType = useSelector((state) => state.roleStepper.roleType);
  
    // Check if data is still loading
    const isLoading = !formData || !modules;
  
    if (isLoading) {
      return (
        <Box sx={{ p: 3 }}>
          <TextSkeletonContainer width="80%" height={30} lines={5} />
        </Box>
      );
    }
  
    // Format modules data: Extract only selected (right-side) permissions
    const selectedPermissions = Object.entries(modules)
      .map(([moduleId, module]) => ({
        moduleName: module.moduleName,
        permissionData: module.right, // Only selected permissions
      }))
      .filter((module) => module.permissionData.length > 0); // Remove empty modules

  
    return (
      <Box sx={{ width: "100%", bgcolor: "background.paper", p: 3 }}>
        {/* Role Details Section */}
        <Box sx={{ mb: 4 }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="textSecondary">
              Role
            </Typography>
            <Typography variant="body1" sx={{ color: "#1d1b20", mt: 1 }}>
              {formData?.name}
            </Typography>
          </Box>
  
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="textSecondary">
              Role Description
            </Typography>
            <Typography variant="body1" sx={{ color: "#1d1b20", mt: 1 }}>
              {formData?.description}
            </Typography>
          </Box>
  
          <Box sx={{ mb: 4 }}>
            <Typography variant="body2" color="textSecondary">
              Role Type
            </Typography>
            <Typography variant="body1" sx={{ color: "#1d1b20", mt: 1 }}>
              {formatEnum(formData?.type) || formatEnum(roleType)}
            </Typography>
          </Box>
        </Box>
  
        {/* Divider Between Role Details and Permissions */}
        <Divider sx={{ my: 3 }} />
  
        {/* Permissions Sections */}
        {selectedPermissions.length > 0 ? (
          selectedPermissions.map((module, moduleIndex) => (
            <Box key={`module-${moduleIndex}`} sx={{ mb: 3 }}>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1.5 }}>
                {module.moduleName}
              </Typography>
  
              {/* Render Permission List */}
              <Grid container spacing={2} sx={{ ml: 2 }}>
                <PermissionList permissionData={module.permissionData} />
              </Grid>
            </Box>
          ))
        ) : (
          <Typography variant="body2" color="textSecondary">
            No permissions available.
          </Typography>
        )}
      </Box>
    );
  };
  
  export default RoleDisplayContainer;